let base_url = "";
let browser_url = "";
let browser_origin = "";

if (typeof window !== "undefined") {
  // `host` is e.g. 'localhost:3000' or 'myom.oldmutual.com.gh'
  browser_url = window.location.host;
  // `origin` includes the protocol, e.g. 'https://myom.oldmutual.com.gh'
  browser_origin = window.location.origin || '';
}

const API_DEV = process.env.REACT_APP_API_URL_DEV || "";
// const API_ALT = process.env.REACT_APP_API_URL_ALT || "";
const API_PROD = process.env.REACT_APP_API_URL_PROD || "";

// Prefer an origin check for exact production domain (handles protocol + host),
// otherwise fall back to matching the host value.
if (browser_origin.startsWith('https://myom.oldmutual.com.gh')) {
  base_url = API_PROD;
} else {
  switch (browser_url) {
    case "localhost:3000":
      base_url = API_DEV;
      // base_url = API_ALT;
      break;
    case "localhost:5000":
      base_url = API_PROD;
      break;
    case "myom.oldmutual.com.gh":
      // hostname only match (no protocol)
      base_url = API_PROD;
      break;
    default:
      // base_url = API_ALT;
      base_url = API_DEV;
      break;
  }
}

if (!base_url) {
  console.warn("⚠️ base_url is empty. Check your .env variables.");
}

const ghanaCardUrl = base_url ? `${base_url}self-service/verify-ghanacard` : "";

export default base_url;
export { ghanaCardUrl };
